import { createContext, useState, useEffect, useCallback } from "react";
import BASE_URL from "../Config/api";

export const ShopContext = createContext();

const ShopContextProvider = ({ children }) => {
  const [all_product, setAllProducts] = useState([]); // optional for catalog
  const [cartItems, setCartItems] = useState([]); // minimal cart info
  const [cartProducts, setCartProducts] = useState([]); // full product info for cart
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("auth-token");

  // =========================
  // FETCH ALL PRODUCTS (FOR CATALOG)
  // =========================
  const fetchAllProducts = useCallback(async () => {
    try {
      const res = await fetch(`${BASE_URL}/allproducts`);
      const data = await res.json();
      setAllProducts(Array.isArray(data.products) ? data.products : []);
    } catch (err) {
      console.error("❌ Products fetch failed", err);
      setAllProducts([]);
    }
  }, []);

  // =========================
  // FETCH CART PRODUCTS BY IDs
  // =========================
  const fetchCartProducts = useCallback(async (cart) => {
    try {
      const ids = cart.map((i) => i.product_id);
      if (ids.length === 0) {
        setCartProducts([]);
        return;
      }

      const res = await fetch(`${BASE_URL}/products/by-ids`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ids }),
      });

      const data = await res.json();
      setCartProducts(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("❌ Cart products fetch failed", err);
      setCartProducts([]);
    }
  }, []);

  // =========================
  // FETCH CART ITEMS
  // =========================
  const fetchCart = useCallback(async () => {
    try {
      let cartData = [];

      if (token) {
        const res = await fetch(`${BASE_URL}/getcart`, {
          method: "POST",
          headers: { "auth-token": token },
        });
        const data = await res.json();
        cartData = Array.isArray(data)
          ? data.map((i) => ({
              product_id: i.product_id,
              size: i.size || null,
              qty: i.qty,
            }))
          : [];
      } else {
        const guestCart = localStorage.getItem("guest_cart");
        cartData = guestCart ? JSON.parse(guestCart) : [];
      }

      setCartItems(cartData);
      await fetchCartProducts(cartData); // load full product details
    } catch (err) {
      console.error("❌ Cart fetch failed", err);
      setCartItems([]);
      setCartProducts([]);
    }
  }, [token, fetchCartProducts]);

  // =========================
  // INIT LOAD
  // =========================
  useEffect(() => {
    const init = async () => {
      setLoading(true);
      await fetchAllProducts(); // optional
      await fetchCart();
      setLoading(false);
    };
    init();
  }, [fetchAllProducts, fetchCart]);

  // =========================
  // SYNC GUEST CART TO LOCALSTORAGE
  // =========================
  useEffect(() => {
    if (!token && !loading) {
      localStorage.setItem("guest_cart", JSON.stringify(cartItems));
    }
  }, [cartItems, token, loading]);

  // =========================
  // ADD TO CART
  // =========================
  const addToCart = async (product_id, size, qty = 1) => {
    const newCart = [...cartItems];
    const exist = newCart.find((i) => i.product_id === product_id && i.size === size);

    if (exist) {
      exist.qty += qty;
    } else {
      newCart.push({ product_id, size, qty });
    }

    setCartItems(newCart);
    await fetchCartProducts(newCart);

    if (token) {
      await fetch(`${BASE_URL}/addtocart`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "auth-token": token },
        body: JSON.stringify({ product_id, size, qty }),
      });
    }
  };

  // =========================
  // REMOVE FROM CART
  // =========================
  const removeFromCart = async (product_id, size, qty = null) => {
    let updatedCart = cartItems.map((i) => {
      if (i.product_id === product_id && i.size === size) {
        if (!qty || i.qty - qty <= 0) return null;
        return { ...i, qty: i.qty - qty };
      }
      return i;
    }).filter(Boolean);

    setCartItems(updatedCart);
    await fetchCartProducts(updatedCart);

    if (token) {
      await fetch(`${BASE_URL}/removefromcart`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "auth-token": token },
        body: JSON.stringify({ product_id, size }),
      });
    }
  };

  // =========================
  // TOTALS
  // =========================
  const getTotalCartItems = () => cartItems.reduce((t, i) => t + i.qty, 0);

  const getTotalCartAmount = () =>
    cartItems.reduce((total, item) => {
      const product = cartProducts.find((p) => p.product_id === item.product_id);
      return product ? total + item.qty * Number(product.new_price || 0) : total;
    }, 0);

  const clearCart = () => {
    setCartItems([]);
    setCartProducts([]);
    if (!token) localStorage.removeItem("guest_cart");
  };

  return (
    <ShopContext.Provider
      value={{
        all_product,
        cartItems,
        cartProducts,
        loading,
        addToCart,
        removeFromCart,
        clearCart,
        getTotalCartItems,
        getTotalCartAmount,
      }}
    >
      {children}
    </ShopContext.Provider>
  );
};

export default ShopContextProvider;





// import { createContext, useState, useEffect, useCallback } from "react";
// import BASE_URL from '../Config/api';
// export const ShopContext = createContext();

// export const ShopContextProvider = (props) => {
//   const [all_product, setAllProducts] = useState([]);
//   const [cartItems, setCartItems] = useState([]);

//   const token = localStorage.getItem("auth-token");

//   // =========================
//   // LOAD ALL PRODUCTS
//   // =========================
// const fetchAllProducts = useCallback(async () => {
//   try {
//     const res = await fetch(`${BASE_URL}/allproducts`);
//     const data = await res.json();

//     console.log("📦 allproducts API response:", data);

//     // ✅ CORRECT FIX
//     setAllProducts(Array.isArray(data.products) ? data.products : []);
//   } catch (err) {
//     console.error("❌ Error fetching all products:", err);
//     setAllProducts([]);
//   }
// }, []);

//   // =========================
//   // LOAD CART (AUTH OR GUEST)
//   // =========================
//   const fetchCart = useCallback(async () => {
//     if (token) {
//       // AUTH USER CART FROM DB
//       const res = await fetch(`${BASE_URL}/getcart`, {
//         method: "POST",
//         headers: { "auth-token": token },
//       });

//       const data = await res.json();
//       setCartItems(
//         data.map((item) => ({
//           product_id: item.product_id,
//           size: item.size,
//           qty: item.qty,
//         }))
//       );
//     } else {
//       // GUEST CART FROM LOCAL STORAGE
//       const guestCart = localStorage.getItem("guest_cart");
//       if (guestCart) {
//         setCartItems(JSON.parse(guestCart));
//       } else {
//         setCartItems([]);
//       }
//     }
//   }, [token]);


//   useEffect(() => {
//     fetchAllProducts();
//     fetchCart();
//   }, [fetchAllProducts, fetchCart]);

//   // =========================
//   // SYNC GUEST CART TO STORAGE
//   // =========================
//   useEffect(() => {
//     if (!token) {
//       localStorage.setItem("guest_cart", JSON.stringify(cartItems));
//     }
//   }, [cartItems, token]);

//   // =========================
//   // ADD TO CART
//   // =========================
//   const addToCart = async (product_id, size, qty = 1) => {
//     setCartItems((prev) => {
//       const existing = prev.find(
//         (i) => i.product_id === product_id && i.size === size
//       );

//       if (existing) {
//         return prev.map((i) =>
//           i.product_id === product_id && i.size === size
//             ? { ...i, qty: i.qty + qty }
//             : i
//         );
//       }

//       return [...prev, { product_id, size, qty }];
//     });
   
//     // BACKEND SYNC (AUTH USER ONLY)
//     if (token) {
//       await fetch(`${BASE_URL}/addtocart`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "auth-token": token,
//         },
//         body: JSON.stringify({
//           product_id: product_id,
//           size,
//           qty,
//         }),
//       });
//     }
//   };

//   // =========================
//   // REMOVE FROM CART
//   // =========================
//   const removeFromCart = async (product_id, size, qty = null) => {
//     setCartItems((prev) => {
//       const existing = prev.find(
//         (i) => i.product_id === product_id && i.size === size
//       );

//       if (!existing) return prev;

//       if (qty === null || existing.qty - qty <= 0) {
//         return prev.filter(
//           (i) => !(i.product_id === product_id && i.size === size)
//         );
//       }

//       return prev.map((i) =>
//         i.product_id === product_id && i.size === size
//           ? { ...i, qty: i.qty - qty }
//           : i
//       );
//     });

//     // BACKEND SYNC (AUTH USER ONLY)
//     if (token) {
//       await fetch(`${BASE_URL}/removefromcart`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "auth-token": token,
//         },
//         body: JSON.stringify({
//           product_id: product_id,
//           size,
//         }),
//       });
//     }
//   };

//   // =========================
//   // TOTAL CART ITEMS
//   // =========================
//   const getTotalCartItems = () => {
//     return cartItems.reduce((t, i) => t + i.qty, 0);
//   };

//   // =========================
//   // TOTAL CART AMOUNT
//   // =========================
//   const getTotalCartAmount = () => {
//     return cartItems.reduce((total, item) => {
//       const product = all_product.find(
//         (p) => p.product_id === item.product_id
//       );

//       if (!product) return total;
//       return total + item.qty * Number(product.new_price || 0);
//     }, 0);
//   };

// const clearCart = () => {
//   setCartItems([]);

//   // GUEST USER
//   if (!token) {
//     localStorage.removeItem("guest_cart");
//   }

//   // AUTH USER
//   // ❌ No API available → frontend clear is enough
// };


//   const contextValue = {
//     all_product,
//     cartItems,
//     clearCart,
//     addToCart,
//     removeFromCart,
//     getTotalCartItems,
//     getTotalCartAmount,
//   };

//   return (
//     <ShopContext.Provider value={contextValue}>
//       {props.children}
//     </ShopContext.Provider>
//   );
// };

// export default ShopContextProvider;

// import { createContext, useState, useEffect, useCallback } from "react";

// export const ShopContext = createContext();

// export const ShopContextProvider = (props) => {
//   const [all_product, setAllProducts] = useState([]); // ✅ always an array
//   const [cartItems, setCartItems] = useState([]);

//   const token = localStorage.getItem("auth-token");

//   // =========================
//   // LOAD ALL PRODUCTS
//   // =========================
// const fetchAllProducts = useCallback(async () => {
//   try {
//     const res = await fetch("${BASE_URL}/allproducts");
//     const data = await res.json();

//     console.log("📦 allproducts API response:", data);

//     // ✅ CORRECT FIX
//     setAllProducts(Array.isArray(data.products) ? data.products : []);
//   } catch (err) {
//     console.error("❌ Error fetching all products:", err);
//     setAllProducts([]);
//   }
// }, []);


//   // =========================
//   // LOAD CART (AUTH OR GUEST)
//   // =========================
//   const fetchCart = useCallback(async () => {
//     try {
//       if (token) {
//         const res = await fetch("${BASE_URL}/getcart", {
//           method: "POST",
//           headers: { "auth-token": token },
//         });
//         const data = await res.json();
//         setCartItems(
//           Array.isArray(data)
//             ? data.map((item) => ({
//                 product_id: item.product_id,
//                 size: item.size,
//                 qty: item.qty,
//               }))
//             : []
//         );
//       } else {
//         const guestCart = localStorage.getItem("guest_cart");
//         setCartItems(guestCart ? JSON.parse(guestCart) : []);
//       }
//     } catch (err) {
//       console.error("Error fetching cart:", err);
//       setCartItems([]);
//     }
//   }, [token]);

//   useEffect(() => {
//     fetchAllProducts();
//     fetchCart();
//   }, [fetchAllProducts, fetchCart]);

//   // =========================
//   // SYNC GUEST CART TO STORAGE
//   // =========================
//   useEffect(() => {
//     if (!token) {
//       localStorage.setItem("guest_cart", JSON.stringify(cartItems));
//     }
//   }, [cartItems, token]);

//   // =========================
//   // ADD TO CART
//   // =========================
//   const addToCart = async (product_id, size, qty = 1) => {
//     setCartItems((prev) => {
//       const existing = prev.find(
//         (i) => i.product_id === product_id && i.size === size
//       );

//       if (existing) {
//         return prev.map((i) =>
//           i.product_id === product_id && i.size === size
//             ? { ...i, qty: i.qty + qty }
//             : i
//         );
//       }

//       return [...prev, { product_id, size, qty }];
//     });

//     if (token) {
//       await fetch("${BASE_URL}/addtocart", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "auth-token": token,
//         },
//         body: JSON.stringify({ product_id, size, qty }),
//       });
//     }
//   };

//   // =========================
//   // REMOVE FROM CART
//   // =========================
//   const removeFromCart = async (product_id, size, qty = null) => {
//     setCartItems((prev) => {
//       const existing = prev.find(
//         (i) => i.product_id === product_id && i.size === size
//       );

//       if (!existing) return prev;

//       if (qty === null || existing.qty - qty <= 0) {
//         return prev.filter(
//           (i) => !(i.product_id === product_id && i.size === size)
//         );
//       }

//       return prev.map((i) =>
//         i.product_id === product_id && i.size === size
//           ? { ...i, qty: i.qty - qty }
//           : i
//       );
//     });

//     if (token) {
//       await fetch("${BASE_URL}/removefromcart", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "auth-token": token,
//         },
//         body: JSON.stringify({ product_id, size }),
//       });
//     }
//   };

//   // =========================
//   // TOTAL CART ITEMS
//   // =========================
//   const getTotalCartItems = () => {
//     return cartItems.reduce((t, i) => t + i.qty, 0);
//   };

//   // =========================
//   // TOTAL CART AMOUNT
//   // =========================
//   const getTotalCartAmount = () => {
//     if (!Array.isArray(all_product)) return 0; // ✅ safeguard

//     return cartItems.reduce((total, item) => {
//       const product = all_product.find(
//         (p) => p.product_id === item.product_id
//       );
//       if (!product) return total;
//       return total + item.qty * Number(product.new_price || 0);
//     }, 0);
//   };

//   const contextValue = {
//     all_product,
//     cartItems,
//     addToCart,
//     removeFromCart,
//     getTotalCartItems,
//     getTotalCartAmount,
//   };

//   return (
//     <ShopContext.Provider value={contextValue}>
//       {props.children}
//     </ShopContext.Provider>
//   );
// };

// export default ShopContextProvider;
